import { types } from "../actions";

const initialState = {
  rules: [],
  loading: false,
  error: null
};

const alertsListReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.RULES_LIST_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };
    case types.RULES_LIST_SUCCESS:
      return {
        ...state,
        rules: action.response,
        loading: false
      };
    case types.RULES_LIST_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error
      };
    default:
      return state;
  }
};

export default alertsListReducer;
